import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main column gap-3 justify-content-center" }
const _hoisted_2 = { class: "column gap-1 text-align-left" }
const _hoisted_3 = { class: "body xl font-bold" }
const _hoisted_4 = { class: "body m font-regular" }
const _hoisted_5 = { class: "w-100" }

import NoAccountSection from '@/components/auth/NoAccountSection.vue';
import FormButton from '@/components/common/button/FormButton.vue';
import TextField from '@/components/common/text-field/TextField.vue';
import { useAuthFlow } from '@/composables/useAuthFlow';
import RouteNames from '@/configuration/router/names.routes';
import navigationService from '@/services/NavigationService';
import { useToasterStore } from '@/stores/useToasterStore';
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'FranceAuth',
  setup(__props) {

const { t } = useI18n();
const toaster = useToasterStore();
const { processFrenchAuth } = useAuthFlow();

const formUserValue = ref<string>('');
const formPasswordValue = ref<string>('');

const isFormDisabled = computed(() => {
  return !formUserValue.value || !formPasswordValue.value;
});

async function loginUser(): Promise<void> {
  try {
    if (!formUserValue.value || !formPasswordValue.value) {
      toaster.error({
        title: t('login.toast.error_general'),
        body: t('login.toast.empty-fields')
      });
      return;
    }

    const isAuthenticated = await processFrenchAuth(
      formUserValue.value,
      formPasswordValue.value
    );

    if (isAuthenticated) {
      navigationService.navigateTo({ name: RouteNames.Home });
    } else {
      throw new Error('Authentication failed');
    }
  } catch (err) {
    if (typeof err === 'string') {
      toaster.error({
        title: t('login.toast.error.title'),
        body: t(`login.toast.${err}`)
      });
      return;
    }

    toaster.error({
      title: t('login.toast.error.title'),
      body: t('login.toast.error')
    });
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)('login.title')), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)('login.form-message')), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(TextField, {
        modelValue: formUserValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formUserValue).value = $event)),
        label: _unref(t)('login.form.user'),
        placeHolder: _unref(t)('login.form.user.placeholder'),
        required: true
      }, null, 8, ["modelValue", "label", "placeHolder"]),
      _createVNode(TextField, {
        modelValue: formPasswordValue.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formPasswordValue).value = $event)),
        label: _unref(t)('login.form.password'),
        type: "password",
        placeHolder: _unref(t)('login.form.password.placeholder'),
        required: true
      }, null, 8, ["modelValue", "label", "placeHolder"])
    ]),
    _createVNode(FormButton, {
      label: _unref(t)('login.form.submit'),
      size: "large",
      onClick: loginUser,
      disabled: isFormDisabled.value,
      "class-name": "w-100 "
    }, null, 8, ["label", "disabled"]),
    _createVNode(NoAccountSection)
  ]))
}
}

})